module.exports = __webpack_public_path__ + "static/media/Background.8c78889a.png";